export default __webpack_public_path__ + "static/media/TrendDown.115da2f9.svg";